import React from "react";
import AppRouter from "./AppRoutes";
import "leaflet/dist/leaflet.css";

export default function App() {
  return (
    <div className="app-container">
      <AppRouter />
    </div>
  );
}